const translator = {
  username: 'نام کاربری',
  password: 'رمزعبور',
  rPassword: 'تکرار رمزعبور',
  confirm: 'تایید',
  phone: 'شماره تلفن همراه',
  mail: 'ایمیل',
  signUp: 'ثبت نام',
  NID: 'کد ملی',
  help: 'راهنما',
  firstname: 'نام',
  lastname: 'نام خانوادگی',
  sender: 'ارسال کننده',
  sendDate: 'زمان ارسال',
  congratulations: 'تبریک',
  chooseOne: 'لطفا یکی از گزینه‌های زیر را انتخاب کنید',
  student: 'دانش آموز',
  Certificat: 'گواهی',
  students: 'دانش آموزان',
  teacher: 'دبیر',
  teachers: 'دبیران',
  allUsers: 'تمام کاربران',
  agent: 'نماینده',
  agents: 'نمایندگان',
  school: 'مدرسه',
  author: 'طراح',
  management: 'مدیریت',
  authors: 'مولفین',
  schools: 'مدارس',
  advisor: 'مشاور',
  advicing: 'مشاوره',
  advicingForAdvisors: 'مشاوره - مخصوص مشاوران',
  price: 'قیمت :',
  priceUnit: 'تومان',
  advisors: 'مشاوران آیریسک',
  iryscTeachers: 'مدرسین آیریسک',
  stats: 'آمار',
  generalStats: 'آمار کلی',
  sellReport: 'گزارش فروش سامانه',
  teach: 'تدریس',
  teachForTeachers: 'تدریس مخصوص دبیران',
  teaches: 'تدریس\u200cها',
  entrance: 'ورود',
  continue: 'ادامه',
  support: 'پشتیبانی',
  email: 'آدرس ایمیل',
  home: 'خانه',
  comments: 'نظرات',
  dashboard: 'پیشخوان',
  myGeneralQuizes: 'آزمون‌های من',
  myQuizes: 'آزمون‌های آیریسکی من',
  myCustomQuizess: 'آزمون‌های شخصی من',
  mySchoolQuizess: 'طراحی آزمون',
  myStudentRequests: 'درخواست‌های رسیده',
  mySchool: 'مدرسه من',
  packages: 'دوره‌های آموزشی',
  myPackages: 'دوره‌های من',
  buyPackages: 'خرید دوره آمورشی',
  quiz: 'آزمون',
  buyQuiz: 'خرید آزمون طراحی شده',
  myAdvisor: 'مشاور من',
  mySchedules: 'برنامه‌های مطالعه من',
  makeQuiz: 'ساخت آزمون شخصی',
  quizes: 'آزمون‌ها',
  videos: 'لیست ویدیوها',
  bookmarkedVideos: 'ویدیوهای نشان‌شده',
  hws: 'تمرین‌ها',
  notifs: 'پیام‌های گروهی',
  innerNotifs: 'پیام‌های درون سایتی',
  mailNotifs: 'پیام‌های ایمیلی',
  smslNotifs: 'پیام‌های پیامکی',
  tag: 'تگ',
  teachReports: 'گزارشات مشکل تدریس',
  adviceReports: 'گزارشات مشکل مشاوره',
  avatars: 'مدیریت تصاویر آواتار',
  charge: 'کیف پول',
  myCerts: 'گواهی‌های من',
  history: 'تراکنش‌ها',
  finantialHistory: 'سوابق مالی',
  config: 'تنظیمات',
  configuration: 'پیکربندی',
  generalConfiguration: 'پیکربندی کلی',
  certificateConfiguration: 'پیکربندی گواهی نفرات برتر',
  ravanConfiguration: 'پیکربندی آزمون‌های روان شناسی',
  shopConfiguration: 'پیکربندی فروشگاه',
  requests: 'ارتباط و پشتیبانی',
  myComments: 'نظرات من',
  commentsAboutMe: 'نظرات درباره من',
  requestsLog: 'درخواست‌های مشاوره',
  users: 'کاربران',
  pleaseFillAllFields: 'لطفا تمام فیلدهای لازم را پر نمایید.',
  invalidFieldValue: 'مقدار وارد شده صحیح نمی باشد.',
  opErr: 'خطایی در انجام عملیات موردنظر رخ داده است',
  noQuiz: 'آزمونی موجود نیست',
  noResult: 'نتیجه‌ای یافت نشد',
  necessary: 'ضروری',
  necessaryField: 'این فیلد ضروری است.',
  notNecessary: 'این فیلد ضروری نیست',
  cancel: 'انصراف',
  sex: 'جنسیت',
  state: 'استان',
  city: 'شهر',
  grade: 'پایه تحصیلی',
  lesson: 'درس',
  subject: 'حیطه',
  tel: 'شماره تماس',
  branch: 'رشته',
  change: 'تغییر',
  doChange: 'اعمال تغییر',
  confirmChanges: 'ثبت تغییرات',
  horizontal: 'افقی',
  vertical: 'عمودی',
  center: 'مرکز:',
  nextStep: 'مرحله بعد',
  desc: 'توضیحات',
  optional: 'اختیاری',
  ticket: 'درخواست پشتیبانی',
  nullAns: 'نزده',
  yes: 'بله',
  no: 'خیر',
  hide: 'عدم نمایش',
  show: 'نمایش',
  // toHide: 'تغییر وضعیت نمایش به عدم نمایش',
  // toShow: 'تغییر وضعیت نمایش به نمایش',
  toHide: 'مخفی',
  toShow: 'نمایش',
  optionalField: '(این فیلد اختیاری است)',
  optionalFalseDefault: 'اختیاری(پیش فرض این فیلد خیر است)',
  optionalTrueDefault: 'اختیاری(پیش فرض این فیلد بله است)',
  chooseFile: 'انتخاب فایل',
  uploading: 'در حال آپلود',
  offsBonus: 'تخفیف و جایزه',
  pleaseWait: 'لطفا شکیبا باشید',
  processRunnig: 'پروسه در حال اجرا',
  fileAdressFor: 'آدرس فایل آپلود شده برای',
  nesFile: 'توضیحات آزمون',
  copyLink: 'کپی کردن لینک',
  copied: 'کپی شد!',
  delete: 'حذف',
  upload: 'بارگذاری فایل',
  notChooseFile: 'هنوز فایلی انتخاب نشده است',
  maxSize: 'حداکثر حجم ',
  format: 'فرمت',
  success: 'عملیات موردنظر با موفقیت انجام شد',
  paid: 'مقدار پرداختی',
  searchBy: 'خصوصیت یکتا',
  nameAndLast: 'نام و نام خانوادگی',
  search: 'جست و جو',
  wantedUser: 'دانش آموز موردنظر',
  deleteAll: 'حذف همه',
  edit: 'ویرایش',
  opMenu: 'منو عملیات',
  op: 'عملیات کلی',
  operation: 'عملیات',
  sureRemove: 'آیا از حذف آیتم/آیتم‌های موردنظر اطمینان دارید؟',
  NIDs: 'کد ملی دانش آموزان مدنظر',
  NIDHelp: 'چندین کد ملی را با استفاده از , جدا کنید',
  createdAt: 'زمان ایجاد',
  answerAt: 'زمان پاسخ',
  amount: 'مبلغ',
  advancedSearch: 'جستجوی پیشرفته',
  update: 'ویرایش',
  all: 'همه',
  pageNotFound: 'صفحه موردنظر یافت نشد.',
  sampad: 'سمپاد',
  gheyr: 'غیرانتفاعی',
  sayer: 'سایر',
  nemone: 'نمونه دولتی',
  heyat: 'هیئت امنایی',
  dolati: 'دولتی',
  aval: 'متوسطه اول',
  dovom: 'متوسطه دوم',
  dabestan: 'دبستان',
  address: 'آدرس',
  add: 'افزودن',
  access: 'دسترسی',
  status: 'وضعیت',
  searchUser: 'یافتن دانش آموز',
  changeStatus: 'تغییر وضعیت',
  changeLevel: 'تغییر سطح',
  changePassword: 'تغییر رمز عبور',
  repeat: 'تکرار',
  currentLevel: 'سطح فعلی',
  newLevel: 'سطح جدید',
  confrim: 'ثبت',
  basicDefinition: 'تعاریف پایه',
  gradeDefinition: 'تعریف مقاطع ',
  lessonsDefinitionInGrades: 'تعریف دروس در رشته‌های المپیادی',
  lessonsDefinitionInBranches: 'تعریف دروس در مقاطع تحصیلی',
  subjectDefinition: 'تعریف حیطه',
  nameContent: 'نام محتوا',
  necessaryContent: 'توضیحات ضروری',
  title: 'عنوان',
  digestMsg: 'خلاصه متن پیام',
  finantialManagement: 'مدیریت مالی',
  offcode: 'کد تخفیف',
  report: 'گزارشات',
  questionReport: 'گزارش خرابی سوال',
  logout: 'خروج',
  profile: 'پروفایل',
  profileConfig: 'موارد قابل نمایش در پروفایل',
  hello: 'سلام',
  seeInfo: 'مشاهده اطلاعات',
  settlementRequests: 'درخواست\u200cهای تسویه',
  isOlympiad: 'آیا جز مقاطع تحصیلی است؟',
  listQuiz: 'لیست آزمون‌ها',
  consultants: ' مشاوران ',
  course: ' درسی ',
  lifeStyle: ' سبک زندگی ',
  examTags: ' آزمون‌ها ',
  openQuiz: 'لیست آزمون‌های باز',
  onlineStanding: 'آزمون‌های آنلاین استندیگ',
  escapeQuiz: 'آزمون فرار',
  schoolQuiz: 'لیست آزمون‌های مدرسه',
  advisorQuiz: 'لیست آزمون‌های مشاور',
  iryscQuiz: 'لیست آزمون‌های آیریسک',
  customQuiz: 'لیست آزمون‌های شخصی',
  contentQuiz: 'لیست آزمون‌های مخصوص دوره‌های آموزشی',
  packageQuiz: 'بسته‌های آزمون',
  haveQuiz: 'آزمون‌های موجود',
  name: 'نام',
  addBatch: 'افزودن دسته ای',
  questions: 'سوالات',
  question: 'سوال',
  showMore: 'نمایش بیشتر',
  showLess: 'نمایش کمتر',
  more: 'اطلاعات بیشتر',
  less: 'اطلاعات کمتر',
  from: 'از ',
  to: ' تا ',
  visibility: 'وضعیت نمایش',
  select: 'انتخاب',
  selected: 'انتخاب شده',
  selectAll: 'انتخاب همه',
  back: 'بازگشت',
  unit: 'واحد',
  Learn: 'آموزش',
  nes: 'فوریت',
  view: 'مشاهده',
  forView: 'برای مشاهده',
  finished: 'خاتمه شده',
  date: 'تاریخ',
  spinGift: 'گردونه شانس',
  winList: 'لیست برند گان',
  selectGift: 'مشخص کردن جوایز',
  priority: 'اولویت',
  used: 'استفاده شده',
  coin: 'ایکس پول',
  money: 'پول',
  counter: 'تعداد',
  dateExpire: 'تاریخ انقضا',
  prob: 'احتمال',
  addDate: 'اضافه کردن تاریخ',
  web: 'وب',
  app: 'اپ',
  print: 'چاپ',
  tarazLevels: 'سطوح تراز',
  badges: 'مدال\u200cها',
  levels: 'سطوح',
  points: 'امتیازات',
  exchanges: 'تبدیلات ایکس پول',
  dailyAdv: 'تبلیغات روزانه',
  level: 'مقطع',
  successOffCode: 'کد تخفیف موردنظر با موفقیت اعمال گردید',
  shouldLogin: 'لطفا ابتدا لاگین کنید',
  transactionResult: 'نتیجه تراکنش',
  successTransaction: 'تراکنش موردنظر با موفقیت انجام شد.',
  removeSuccessfully: 'فایل موردنظر با موفقیت حذف گردید',
  transactionFinantial: 'تراکنش‌های مالی',
  section_: 'بخش',
  section: 'مورد استفاده',
  recp: 'رسید پرداخت',
  registeredAt: 'تاریخ ثبت نام',
  downloadRecp: 'دریافت رسید پرداخت',
  start: 'شروع',
  go: 'بروید',
  clickHere: 'اینجا را کلیک کنید',
  filter: 'اعمال فیلتر',
  contents: 'دوره‌های آموزشی',
  listContents: 'لیست دوره‌های آموزشی',
  faqContents: 'سوالات متداول',
  advContents: 'ویدیوهای تبلیغاتی',
  packageLevels: 'سطوح دوره ها',
  seoContents: 'سئو',
  teachersContents: 'مدرسان',
  copySessions: 'کپی کردن جلسات',
  contentMissed: 'خرابی‌های دوره‌های آموزشی',
  results: 'نتایج',
  free: 'رایگان',
  clearFilters: 'پاک کردن فیلترها',
  showFilters: 'نمایش فیلتر',
  lessFilters: 'بستن فیلتر',
  has: 'دارد',
  not_has: 'ندارد',
  col: ': ',
  questionReportTags: 'تگ‌های گزارش خرابی سوال',
  teachReportTags: 'تگ‌های گزارش مشکل برای تدریس',
  adviceReportTags: 'تگ‌های گزارش مشکل برای مشاوره',
  educationalHistory: 'سوابق تحصیلی',
  birthDay: 'تاریخ تولد',
  myFinancePlans: 'مدیریت بسته‌ها',
  myTeachSchedules: 'برنامه\u200Cهای تدریس من',
  myTeachRequests: 'درخواست\u200Cهای رسیده',
  myTeachTransactions: 'حق التدریس\u200cهای من',
  allTeachTransactions: 'حق التدریس\u200cها',
  myClassess: 'جلسات من',
  myRequests: 'درخواست\u200Cهای من',
  pending: 'در حال بررسی',
  accepted: 'تایید شده',
  rejected: 'رد شده',
  reject: 'رد کردن',
  accept: 'تایید کردن',
  detail: 'جزئیات',
  unknow: 'ناشناخته',
  lastNotifs: 'اعلانات اخیر دیده نشده',
  rate: 'امتیاز',
  age: 'سن',
};
export default translator;
